import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { OVIDProvider } from '@outdoor-voices/ui/dist/utils/customer/OVIDProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import { COOKIE_DOMAIN, JWT_COOKIE_NAME } from './apps/customers/constants';
import { OV_ID_URL } from './config/theme';
import props from './components/SMSSignUp/props';
import SMSSignUp from './components/SMSSignUp';
import { jsx as _jsx } from "react/jsx-runtime";
ReactDOM.render( /*#__PURE__*/_jsx(OVIDProvider, {
  domain: COOKIE_DOMAIN,
  name: JWT_COOKIE_NAME,
  url: OV_ID_URL,
  children: /*#__PURE__*/_jsx(SMSSignUp, _objectSpread({}, props))
}), document.getElementById('page-sms-sign-up'));